import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { getChildByKey } from '../../../shared/helpers/functions/markup';

export default function PlanExampleContainer({
  children,
}: {
  children: ReactNode[];
}) {
  const title = getChildByKey(children, 'title');
  const description = getChildByKey(children, 'description');
  const content = getChildByKey(children, 'content');

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: theme.palette.grey[25],
        p: '12px 8px',
        borderRadius: '8px',
      })}
    >
      <Typography variant="h4">{title}</Typography>
      {description && <Typography variant="body2">{description}</Typography>}
      {content}
    </Box>
  );
}
